import PetsIcon from "@mui/icons-material/Pets";
import React, { Fragment, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PetsGrid from "../../components/display/PetsGrid";
import FullScreenMessageCore from "../../components/fullScreenMessage/FullScreenMessageCore";
import NotFoundFullScreenMessage from "../../components/fullScreenMessage/NotFoundFullScreenMessage";
import { Box, Skeleton, Stack } from "@mui/material";
import CustomDrawer from "../../components/wrappers/CustomDrawer";
import PageContentWrapper from "../../components/wrappers/PageContentWrapper";
import { GlobalDataContext } from "../../contexts/GlobalData";
import ToggleDrawer from "../../contexts/ToggleDrawer";
import { ADD_PET, CLINIC_PETS } from "../../enums/ApiPaths";
import { CREATE_PET } from "../../enums/PermissionTitles";
import { PETS } from "../../enums/QueryKeys";
import { useFetch } from "../../hooks/Fetching";
import useUser, { useGetUserId } from "../../hooks/useUser";
import AddPetForm from "./form/AddPetForm";
import { useIsMobile } from "../../utils/Functions";
import ChooseAClinicFullScreenMessage from "../../components/fullScreenMessage/ChooseAClinicFullScreenMessage";

export default function Pets() {
  const { roles, currentClinic } = useUser();
  const userId = useGetUserId();
  const path = roles.adminOrEmployee ? CLINIC_PETS : ADD_PET;
  const requestId = roles.adminOrEmployee ? currentClinic?.id : userId;
  const { data, isLoading, error } = useFetch(path, requestId, PETS);

  const { isPermissionAllowed } = React.useContext(GlobalDataContext);
  const { t } = useTranslation();
  const hasPermission = isPermissionAllowed(CREATE_PET);

  const pets = data;
  const diplayPets = pets?.length > 0;

  const PetsSkeletonGrid = ({ numOfSkeletons = 6 }) => {
    const isMobile = useIsMobile();
    const skeletonArray = Array.from({ length: numOfSkeletons });

    return (
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: isMobile ? "20%" : "76px",
        }}
      >
        {skeletonArray.map((_, i) => (
          <Box
            key={i}
            style={{
              width: 120,
              height: 160,
              marginBottom: isMobile ? "12px" : 0,
            }}
          >
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              sx={{
                borderRadius: 2,
                opacity: 1 - i * 0.15,
              }}
            />
          </Box>
        ))}
      </Box>
    );
  };

  if (currentClinic.id == null) {
    return <ChooseAClinicFullScreenMessage/>
  }

  if (isLoading) {
    return (
      <PageContentWrapper>
        <PetsSkeletonGrid />
      </PageContentWrapper>
    );
  }

  if (error) {
    return (
      <PageContentWrapper>
        <NotFoundFullScreenMessage />
      </PageContentWrapper>
    );
  }

  return (
    <PageContentWrapper>
      {diplayPets > 0 ? (
        <Fragment>
          <PetsGrid
            loading={isLoading}
            error={error}
            hasPermission={hasPermission}
            displayForm
            petsArray={pets}
          />
        </Fragment>
      ) : (
        <FullScreenMessageCore
          icon={<PetsIcon className="Mui-fullscreen-icon" />}
          title={"YouHaveNoPetsSaved"}
          subtitle={hasPermission ? null : "NoPermissionForThisAction"}
        >
          {hasPermission ? (
            <ToggleDrawer>
              <CustomDrawer buttonMessage={t("AddPet")} buttonSize={"large"} testId="pet.empty-state-drawer">
                <AddPetForm />
              </CustomDrawer>
            </ToggleDrawer>
          ) : null}
        </FullScreenMessageCore>
      )}
    </PageContentWrapper>
  );
}
